module.exports = __webpack_public_path__ + "static/media/order-icon.2997bc1c.svg";